/* 
 * Click nbfs://nbhost/SystemFileSystem/Templates/Licenses/license-default.txt to change this license
 * Click nbfs://nbhost/SystemFileSystem/Templates/Other/javascript.js to edit this template
 */
import * as THREE from 'three';
import * as YUKA from 'yuka';
import {OrbitControls}
from 'three/examples/jsm/controls/OrbitControls.js';
import { GLTFLoader}
from 'three/examples/jsm/loaders/GLTFLoader.js';
import {createGraphHelper}
from './graph_helper.js';
import {createConvexRegionHelper}
from './convex_helper.js';
import { FBXLoader }
from 'three/examples/jsm/loaders/FBXLoader';
import Stats from 'three/examples/jsm/libs/stats.module';
import { Pathfinding }
from 'three-pathfinding';
import { FontLoader }
from 'three/examples/jsm/loaders/FontLoader.js';

import { LineGeometry }
from 'three/examples/jsm/lines/LineGeometry.js';
import { Line2 }
from 'three/examples/jsm/lines/Line2.js';

import { LineMaterial }
from 'three/examples/jsm/lines/LineMaterial.js';

import { RoomEnvironment }
from 'three/examples/jsm/environments/RoomEnvironment.js';

import { TextGeometry }
from 'three/examples/jsm/geometries/TextGeometry.js';

import { SVGRenderer } from 'three/examples/jsm/renderers/SVGRenderer.js';

//const model_url = './assets/jbr8/jbr_model_1410.glb';
const foldername = 'v6';
const model_url = './assets/alsheef/' + foldername + '/base.glb';
const shop_url = './assets/alsheef/' + foldername + '/shop.glb';
const model_text_url = './assets/alsheef/' + foldername + '/text.glb';
const bk_text_url = './assets/jbr4/bk.glb';
const model_nev_mesh = './assets/alsheef/' + foldername + '/navmesh.glb';
const marker = './assets/jbr5/marker.glb';
const jbrlines = './assets/jbr5/outline.glb';

const navmesh_ground = './assets/alsheef/' + foldername + '/navmeshzone2.glb';
const navmesh_stairs = './assets/alsheef/' + foldername + '/stairs.glb';
const navmesh_plaza = './assets/alsheef/' + foldername + '/navmeshzone1.glb';
const locations_url = './assets/alsheefv2.json';
//const locations_url = 'http://localhost:8080/AbookProjects/test.jsp';
const icon_url = './assets/jbr8/jbr_icons_1025.glb';
const youarehere_url = './assets/jbr7/marker2.glb';
const qrcodes_url = './assets/jbr8/jbr_qr_1410.glb';

const allIcons = [
    {objectname: 'amlift1', icon: './assets/icons2/lift.svg'},
    {objectname: 'amlift2', icon: './assets/icons2/lift.svg'},
    {objectname: 'amlift3', icon: './assets/icons2/lift.svg'},
    {objectname: 'amlift4', icon: './assets/icons2/lift.svg'},
    {objectname: 'amlift5', icon: './assets/icons2/lift.svg'},
    {objectname: 'amlift6', icon: './assets/icons2/lift.svg'},
    {objectname: 'amlift7', icon: './assets/icons2/lift.svg'},
    {objectname: 'ammosque', icon: './assets/icons2/mosque.svg'},
    {objectname: 'amwc1', icon: './assets/icons2/wc.svg'},
    {objectname: 'amwc2', icon: './assets/icons2/wc.svg'},
    {objectname: 'bhescalator', icon: './assets/icons2/escalator_flipped.svg'},
    {objectname: 'bhescalatorground', icon: './assets/icons2/escalator_flipped.svg'},
    {objectname: 'bhlift1', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift2', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift3', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift4', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift5', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift6', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift7', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift8', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift9', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift10', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift11', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift12', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift13', icon: './assets/icons2/lift.svg'},
    {objectname: 'bhlift14', icon: './assets/icons2/lift.svg'},

    {objectname: 'bhwc1', icon: './assets/icons2/wc.svg'},
    {objectname: 'bhwc2', icon: './assets/icons2/wc.svg'},
    {objectname: 'mjlift', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift1', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift2', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift3', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift4', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift5', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift6', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift7', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift8', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift9', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift10', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift11', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjlift12', icon: './assets/icons2/lift.svg'},
    {objectname: 'mjwc', icon: './assets/icons2/wc.svg'},
    {objectname: 'mosque', icon: './assets/icons2/mosque.svg'},
    {objectname: 'parking', icon: './assets/icons2/parkingflipped.svg'},
    {objectname: 'rmescalator', icon: './assets/icons2/escalator_flipped.svg'},
    {objectname: 'rmescalatorground', icon: './assets/icons2/escalator_flipped.svg'},
    {objectname: 'rmlift1', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift2', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift3', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift4', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift5', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift6', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift7', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift8', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift9', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift10', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift11', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift12', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmlift13', icon: './assets/icons2/lift.svg'},
    {objectname: 'rmmosque', icon: './assets/icons2/mosque.svg'},
    {objectname: 'rmwc1', icon: './assets/icons2/wc.svg'},
    {objectname: 'rmwc2', icon: './assets/icons2/wc.svg'},
    {objectname: 'rmwc3', icon: './assets/icons2/wc.svg'},
    {objectname: 'sdlift', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdlift1', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdlift2', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdlift3', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdlift4', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdlift5', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdlift6', icon: './assets/icons2/lift.svg'},
    {objectname: 'sdwc', icon: './assets/icons2/wc.svg'},
    {objectname: 'sdwc2', icon: './assets/icons2/wc.svg'},
    {objectname: 'sdwc3', icon: './assets/icons2/wc.svg'},
    {objectname: 'shlift1', icon: './assets/icons2/lift.svg'},
    {objectname: 'shlift2', icon: './assets/icons2/lift.svg'},
    {objectname: 'shlift3', icon: './assets/icons2/lift.svg'},
    {objectname: 'shlift4', icon: './assets/icons2/lift.svg'},
    {objectname: 'shlift5', icon: './assets/icons2/lift.svg'},
    {objectname: 'shlift6', icon: './assets/icons2/lift.svg'},
    {objectname: 'shwc1', icon: './assets/icons2/wc.svg'},
    {objectname: 'shwc2', icon: './assets/icons2/wc.svg'}
];


const colors = {
    PLAYER: 0xEE836F,
    TARGET: 0xDCCB18,
    PATH: 0x00d7ea,
    WAYPOINT: 0x00A3AF,
    CLAMPED_STEP: 0xDCD3B2,
    CLOSEST_NODE: 0x43676B,
};

const OFFSET = 0;

/**
 * Helper for debugging pathfinding behavior.
 */
class PathfindingHelper extends THREE.Object3D {
    constructor() {
        super();

        this._playerMarker = new THREE.Mesh(
                new THREE.SphereGeometry(0.25, 32, 32),
                new THREE.MeshBasicMaterial({color: colors.PLAYER})
                );

        this._targetMarker = new THREE.Mesh(
                new THREE.BoxGeometry(0.3, 0.3, 0.3),
                new THREE.MeshBasicMaterial({color: colors.TARGET})
                );


        this._nodeMarker = new THREE.Mesh(
                new THREE.BoxGeometry(0.1, 0.8, 0.1),
                new THREE.MeshBasicMaterial({color: colors.CLOSEST_NODE})
                );


        this._stepMarker = new THREE.Mesh(
                new THREE.BoxGeometry(0.1, 1, 0.1),
                new THREE.MeshBasicMaterial({color: colors.CLAMPED_STEP})
                );

        this._pathMarker = new THREE.Object3D();

        this._pathLineMaterial = new THREE.LineBasicMaterial({color: colors.PATH, linewidth: 5.0});
        this._pathPointMaterial = new THREE.MeshBasicMaterial({color: colors.WAYPOINT});
        this._pathPointGeometry = new THREE.SphereGeometry(0.08);

        this._markers = [
            this._playerMarker,
            this._targetMarker,
            this._nodeMarker,
            this._stepMarker,
            this._pathMarker,
        ];

        this._markers.forEach((marker) => {

            marker.visible = false;

            this.add(marker);

        });

    }

    /**
     * @param {Array<Vector3>} path
     * @return {this}
     */
    setPath(path) {

        while (this._pathMarker.children.length) {

            this._pathMarker.children[ 0 ].visible = false;
            this._pathMarker.remove(this._pathMarker.children[ 0 ]);

        }


        path = [this._playerMarker.position].concat(path);

        // Draw debug lines
        const geometry = new THREE.BufferGeometry();


        geometry.setAttribute('position', new THREE.BufferAttribute(new Float32Array(path.length * 3), 3));
        for (let i = 0; i < path.length; i++) {
            geometry.attributes.position.setXYZ(i, path[ i ].x, path[ i ].y, path[ i ].z);
        }
        let line = new THREE.Line(geometry, this._pathLineMaterial);

//        this._pathMarker.add(line);

        console.log(path)

        for (var i = 0; i < path.length; i++) {
            path[i].y += OFFSET;
        }

//        for (var i = 0; i < MyXYXarray.length; i++) {
//    aPoints.push(new THREE.Vector3(MyXYXarray[i][0], MyXYXarray[i][1], MyXYXarray[i][2]));
//}
        const scale = 1;
        const pipeSpline = new THREE.CatmullRomCurve3(path);
        pipeSpline.curveType = 'catmullrom';
        pipeSpline.tension = 0;
        const tubeGeometry = new THREE.TubeGeometry(pipeSpline, 500, 0.1, 20, false);
        const wireframeMaterial = new THREE.MeshBasicMaterial({color: colors.PATH, opacity: 1, wireframe: false, transparent: false});
        var mesh = new THREE.Mesh(tubeGeometry, wireframeMaterial);
        mesh.scale.set(scale, scale, scale);
//        mesh.position.y=1;
        var parent = new THREE.Object3D();
        parent.add(mesh);
        this._pathMarker.add(parent);


        for (let i = 0; i < path.length - 1; i++) {


            const node = new THREE.Mesh(this._pathPointGeometry, this._pathPointMaterial);
            node.position.copy(path[ i ]);
//            node.position.y += OFFSET;
            this._pathMarker.add(node);

        }

        this._pathMarker.visible = true;

        return this;

    }

    /**
     * @param {Vector3} position
     * @return {this}
     */
    setPlayerPosition(position) {

        this._playerMarker.position.copy(position);
        this._playerMarker.visible = true;
        return this;

    }

    /**
     * @param {Vector3} position
     * @return {this}
     */
    setTargetPosition(position) {

        this._targetMarker.position.copy(position);
        this._targetMarker.visible = false;
        return this;

    }

    /**
     * @param {Vector3} position
     * @return {this}
     */
    setNodePosition(position) {

        this._nodeMarker.position.copy(position);
        this._nodeMarker.visible = false;
        return this;

    }

    /**
     * @param {Vector3} position
     * @return {this}
     */
    setStepPosition(position) {

        this._stepMarker.position.copy(position);
        this._stepMarker.visible = true;
        return this;

    }

    /**
     * Hides all markers.
     * @return {this}
     */
    reset() {

        while (this._pathMarker.children.length) {

            this._pathMarker.children[ 0 ].visible = false;
            this._pathMarker.remove(this._pathMarker.children[ 0 ]);

        }

        this._markers.forEach((marker) => {

            marker.visible = false;

        });

        return this;

    }

}
const cameraOriginalOffset = 20;
var cameraLastPosition = cameraOriginalOffset;

var currentNavPath = [];
function offsetHeightOfCamera() {
    return cameraLastPosition;
}

class ThirdPersonCamera {
    constructor(params) {
        this._params = params;
        this._camera = params.camera;
        this._currentPosition = new THREE.Vector3();
        this._currentLookat = new THREE.Vector3();
    }

    _CalculateIdealOffset() {
        const idealOffset = new THREE.Vector3(10, offsetHeightOfCamera(), 20);
//        idealOffset.applyQuaternion(this._params.target.quaternion);
        idealOffset.sub(this._params.target.position);
        return idealOffset;
    }

    _CalculateIdealLookAt() {
        const idealLookat = new THREE.Vector3(0, 10, 0);
//        idealLookat.applyQuaternion(this._params.target.quaternion);
        idealLookat.sub(this._params.target.position);
        return idealLookat;
    }

    Update(timeElapsed) {



        const idealOffset = this._CalculateIdealOffset();
        const idealLookat = this._CalculateIdealLookAt();
//        console.log(idealOffset)

        this._currentPosition.copy(idealOffset);
        this._currentLookat.copy(idealLookat);
        //console.log(this._currentPosition);

//        console.log(this._camera)
        this._camera.position.copy(this._currentPosition);
        this._camera.lookAt(this._currentLookat);
//        this._camera.position.y = -(180 * (Math.PI / 180));
    }
}
// SCENE



var canvas = document.createElement("canvas");
canvas.width = window.innerWidth;
canvas.height = window.innerHeight;
var ctx = canvas.getContext("2d");
var grd = ctx.createLinearGradient(0, 0, 0, window.innerHeight);
grd.addColorStop(0, "grey");
grd.addColorStop(.5, "lightgrey");
grd.addColorStop(1, "grey");

ctx.fillStyle = grd;
ctx.fillRect(0, 0, window.innerWidth, window.innerHeight);

var texture = new THREE.CanvasTexture(canvas);


const scene = new THREE.Scene();
scene.background = texture;
scene.rotation.y = -(180 * (Math.PI / 180));


const axesHelper = new THREE.AxesHelper(5);
axesHelper.position.y = 0;
axesHelper.position.x = 0;
//scene.add(axesHelper);
// CAMERA


function addIcon() {

    for (var i = 0; i < allIcons.length; i++) {

        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');


// Set the canvas size
        canvas.width = 1024; // You can adjust the size as needed
        canvas.height = 1024;

// Create an SVG image
        const svgImage = new Image();
        const objnam = allIcons[i].objectname;

        svgImage.onload = () => {
            // Draw the SVG onto the canvas
            ctx.drawImage(svgImage, 0, 0);
            //ctx.scale(-1, 1);
            // Use the canvas as the source for a texture
            const texture = new THREE.Texture(canvas);
            texture.needsUpdate = true;

            // Create material with this texture
            const material = new THREE.MeshBasicMaterial({map: texture, transparent: true});



            var iconplaceholder = scene.getObjectByName(objnam);

            iconplaceholder.material = material;
//            iconplaceholder.scale.multiplyScalar(0.75);
            iconplaceholder.material.needsUpdate = true;

            // Create a mesh and add it to the scene
//        const geometry = new THREE.PlaneGeometry(1, 1);
//        const mesh = new THREE.Mesh(geometry, material);
//        mesh.position.y = 30;
//        scene.add(mesh);

            // Render your scene as usual
        };

// Set the source of the image to the SVG URL
        svgImage.src = allIcons[i].icon;


    }

    loadQRcodePlaceholders();


}





const camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 1, 1000);
let aspect = window.innerWidth / window.innerHeight;
const frustumSize = 600;
//const camera =new THREE.OrthographicCamera( window.innerWidth / - 2, window.innerWidth / 2, window.innerHeight / 2, window.innerHeight / - 2, 1, 1000);

camera.position.y = 20;
camera.position.z = 70;
camera.position.x = 0;
scene.position.x = 3;
//camera.rotation.x = -45 * (Math.PI / 180);
camera.rotation.y = -(180 * (Math.PI / 180));
const originalCameraRotation = camera.rotation;


// RENDERER
const renderer = new THREE.WebGLRenderer({antialias: true, precision: 'mediump'});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.setPixelRatio(window.devicePixelRatio);
renderer.shadowMap.enabled = true;

//const pmremGenerator = new THREE.PMREMGenerator(renderer);
//scene.environment = pmremGenerator.fromScene(new RoomEnvironment(), 0.04).texture;


// ORBIT CAMERA CONTROLS


const orbitControls = new OrbitControls(camera, renderer.domElement);
orbitControls.mouseButtons = {
    RIGHT: THREE.MOUSE.ROTATE,
    LEFT: THREE.MOUSE.PAN
};

orbitControls.touches = {
    ONE: THREE.TOUCH.PAN,
    TWO: THREE.TOUCH.DOLLY_ROTATE
}

//orbitControls.touches.ONE = THREE.TOUCH.PAN;
//orbitControls.touches.TWO = THREE.TOUCH.ROTATE;
orbitControls.enableDamping = false;
//orbitControls.dampingFactor = 0.05;
orbitControls.enableRotate = true;
OrbitControls.enablePan = true;
orbitControls.minDistance = 10;
orbitControls.maxDistance = 500;
orbitControls.maxPolarAngle = Math.PI / 2.2; // prevent camera below ground
orbitControls.minPolarAngle = 0; // prevent top down view
orbitControls.autoRotate = true;
orbitControls.screenSpacePanning = false;
orbitControls.update();
// LIGHTS

var orbitControlStarted = false;
var clickStarttime;
orbitControls.addEventListener('start', event => {
    orbitControlStarted = true;

    //console.log("Started....");

    clickStarttime = new Date();
    // console.log(clickStarttime);

});

orbitControls.addEventListener('end', event => {

    var clickEndtime = new Date();
    // console.log(clickEndtime);
    //console.log(clickEndtime - clickStarttime);
    var diff = clickEndtime - clickStarttime;
    if (diff != 0 && diff < 200) {
        orbitControlStarted = false;
    }
    // orbitControls.update();
    // console.log("Ended....");
});

var stopNavClicked = false;
var navStarted = false;


//orbitControls.addEventListener('change', event => {
//    console.log("current");
//    console.log(camera.rotation);
//    console.log("cameraLastPosition");
//    console.log(cameraLastPosition);
//});

function setToEndPosition() {
    if (navStarted && !stopNavClicked) {
        orbitControls.reset();
        var toShop = checkIfExist($("#to").val());
        setPositionToShop(toShop);
        navStarted = false;
        $("#btnStopNav").addClass("d-none");
        cameraLastPosition = cameraOriginalOffset;
    }
}

function topView() {
    resetAllPos();
    camera.position.x = 0;
    camera.position.y = 30;
    camera.position.z = 0;

    scene.position.x = 0;
    scene.position.z = -30;
    orbitControls.update();


}

function resetAllPos() {

    camera.position.y = 20;
    camera.position.z = 30;
    camera.position.x = 0;
    scene.position.x = 3;
    scene.rotation.y = -(180 * (Math.PI / 180));
    camera.rotation.y = -(180 * (Math.PI / 180));
    orbitControls.reset();
}


const intencity = 0.9;
const distanceLight = 150;
const dLightUp = new THREE.DirectionalLight('white', intencity);
dLightUp.position.x = 0;
dLightUp.position.y = distanceLight;
dLightUp.position.z = 0;
scene.add(dLightUp);

const dLightFront = new THREE.DirectionalLight('white', intencity);
dLightFront.position.x = 0;
dLightFront.position.y = 0;
dLightFront.position.z = -1 * distanceLight;
scene.add(dLightFront);

const dLightLeft = new THREE.DirectionalLight('white', intencity);
dLightLeft.position.x = -1 * distanceLight;
dLightLeft.position.y = 0;
dLightLeft.position.z = 0;
scene.add(dLightLeft);
const dLightRight = new THREE.DirectionalLight('white', intencity);
dLightRight.position.x = distanceLight;
dLightRight.position.y = 0;
dLightRight.position.z = 0;
scene.add(dLightRight);

const dLightBack = new THREE.DirectionalLight('white', intencity);
dLightBack.position.x = 0;
dLightBack.position.y = 0;
dLightBack.position.z = distanceLight;
scene.add(dLightBack);













const aLight = new THREE.AmbientLight('white', 0.1);
scene.add(aLight);

// ATTACH RENDERER
document.getElementById("map").appendChild(renderer.domElement);
// RESIZE HANDLER
function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
}
window.addEventListener('resize', onWindowResize);
var previousPos;
const agentHeight = 1.0;
const agentRadius = 0.25;
const agent = new THREE.Mesh(new THREE.CylinderGeometry(agentRadius, agentRadius, agentHeight), new THREE.MeshPhongMaterial({color: 'green'}));
agent.position.y = 0;
//agent.add(camera);

const agentGroup = new THREE.Group();
//agentGroup.add(agent);
agentGroup.position.z = 0;
agentGroup.position.x = 0;
agentGroup.position.y = 0;
var thirdPersonCamera = new ThirdPersonCamera({
    camera: camera,
    target: agentGroup
});
scene.add(agentGroup);
previousPos = agentGroup.position;
const time = new YUKA.Time();
const loader = new GLTFLoader();













function loadModal() {
    loader.load(model_url, function (gltf) {
        scene.add(gltf.scene);
        //loadText(scene);

        gltf.scene.traverse((node) => {
            if (node.isObject3D) {

                if (node.material && (node.material.name == 'Rimal')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'Sadaf')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#b588a4")
                    });
                    material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                    // console.log(node.name)
                }

                if (node.material && (node.material.name == 'Murjanplaza'
                        || node.material.name == 'Sadafplaza'
                        || node.material.name == 'Baharplaza'
                        || node.material.name == 'Rimalplaza'
                        || node.material.name == 'Amwajplaza'
                        || node.material.name == 'Shamsplaza')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#136c8a")
                    });

                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'Bahar')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'Amwaj')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'Shams')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'Murjan')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'Base')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#aaaaaa")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'road')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#636569")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'ground')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#6f6d6d")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }
                if (node.material && (node.material.name == 'dashed')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#ffffff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'buildcolor')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#1a2e7b")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }
                if (node.material && (node.material.name == 'water')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#3dc3ff")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'addressresort')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#136c8a")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }

                if (node.material && (node.material.name == 'border')) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#979aa0")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }






            }
        });

        loadModalShop();

    });

}

function loadModalShop() {
    loader.load(shop_url, function (gltf) {
        scene.add(gltf.scene);
    });
    loadModalText();
}
function loadModalText() {
    loader.load(model_text_url, function (gltf) {
        scene.add(gltf.scene);

        gltf.scene.traverse((node) => {

            if (node.isObject3D) {
                console.log(node.name);




            }
        });

        loadText(scene);

    });
}
function loadLines() {
//    loader.load(jbrlines, function (gltf) {
//        scene.add(gltf.scene);
//        gltf.scene.traverse((node) => {
//
//            if (node.isObject3D) {
//
//                if (node.material) {
//                    var material2 = new THREE.MeshPhongMaterial({
//                        color: new THREE.Color("#979aa0")
//                    });
//                    node.material = material2;
//                    node.material.needsUpdate = true;
//                }
//            }
//        });
//        loadStairs();
//
//    });

    loadStairs();
}
function loadStairs() {
    loader.load(navmesh_stairs, function (gltf) {
        scene.add(gltf.scene);

        gltf.scene.traverse((node) => {
            if (node.isObject3D) {
                console.log(node.name)
                if (node.material) {

                    // console.log(node.material);
                }
            }
        });

        loadMarker();

    });
}
function loadMarker() {
    loader.load(marker, function (gltf) {
        agentGroup.add(gltf.scene);
        agentGroup.visible = false;
        gltf.scene.traverse((node) => {

            if (node.isObject3D) {

                if (node.material) {
                    var material2 = new THREE.MeshPhongMaterial({
                        color: new THREE.Color("#FF0000")
                    });
                    node.material = material2;
                    node.material.needsUpdate = true;
                }
            }
        });
        //  loadIcons();

    });
}
function loadIcons() {
    loader.load(icon_url, function (gltf) {
        scene.add(gltf.scene);

        gltf.scene.traverse((node) => {
            if (node.isObject3D) {

            }
        });

        addIcon();

    });
}

//createShape(0.5);

function loadQRcodePlaceholders() {
    loader.load(qrcodes_url, function (gltf) {
        scene.add(gltf.scene);
        const locationname = getUrlParameter("location");
        gltf.scene.traverse((node) => {
            if (node.isObject3D) {

                if (locationname) {
                    if (node.name == locationname) {
                        loadYouareHere(node.position.x, 0, node.position.z);
                    }

                }

            }
        });

        // loadYouareHere();

    });
}

function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
}

function loadYouareHere(x, y, z) {
    loader.load(youarehere_url, function (gltf) {



        const grp = new THREE.Group();
//agentGroup.add(agent);
        grp.position.z = z;
        grp.position.x = x;
        grp.position.y = y;
        grp.scale.z = 1;
        grp.scale.x = 1;
        grp.scale.y = 1;
        grp.rotation.y = -(180 * (Math.PI / 180));
        grp.add(gltf.scene);

        scene.add(grp);

        gltf.scene.traverse((node) => {
            if (node.isObject3D) {
                if (node.material) {
                    if (node.material.name != 'text') {
                        var material2 = new THREE.MeshPhongMaterial({
                            color: new THREE.Color("#FF0000")
                        });
                        node.material = material2;
                        node.material.needsUpdate = true;
                    } else {

                        var material2 = new THREE.MeshPhongMaterial({
                            color: new THREE.Color("#FFFFFF")
                        });
                        node.material = material2;
                        node.material.needsUpdate = true;

                    }
                }
            }
        });

        resetAllPos();

        camera.position.x = 0;
        camera.position.y = 30;
        camera.position.z = 0;

        scene.position.x = x;
        scene.position.z = z;
        orbitControls.update();

    });
}


loadModal();






function createShape(size) {
    const heartShape = new THREE.Shape();
    heartShape.moveTo(0, size);
    heartShape.arc(0, size, size, 0, (180 * (Math.PI / 180)), false);
    heartShape.lineTo(0, 0);
    const extrudeSettings = {depth: 0.1, bevelEnabled: true, bevelSegments: 10, steps: 10, bevelSize: 0.1, bevelThickness: 0.1};
    const geometry = new THREE.ExtrudeGeometry(heartShape, extrudeSettings);
    const mesh = new THREE.Mesh(geometry, new THREE.MeshPhongMaterial({color: 'red'}));
    agentGroup.add(mesh);
}



let nav, vehicle;
let line, linegeometry;
const materialLine = new THREE.LineBasicMaterial({color: 0xFFFFFF});
const pathfinding = new Pathfinding();
const pathfindinghelper = new PathfindingHelper();

scene.add(pathfindinghelper);
const ZONE_ground = 'ground';
const ZONE_stairs = 'stairs';
const ZONE_plaza = 'plaza';
const SPEED = 5;
let navmesh;
let groupID;
let navpath;

let navmeshGround;
let navmeshPlaza;
let navmeshStairs;

loader.load(navmesh_ground, function (gltf) {
//      scene.add(gltf.scene);
    gltf.scene.traverse((node) => {
        if (node.isMesh) {
            pathfinding.setZoneData(ZONE_ground, Pathfinding.createZone(node.geometry));
        }

    });
});



loader.load(navmesh_plaza, function (gltf) {
//     scene.add(gltf.scene);
    gltf.scene.traverse((node) => {

        if (node.isObject3D) {

            if (node.material) {
                var material2 = new THREE.MeshPhongMaterial({
                    color: new THREE.Color("#FBBB10")
                });
                node.material = material2;
                node.material.needsUpdate = true;
            }
        }

        if (node.isMesh) {
            pathfinding.setZoneData(ZONE_plaza, Pathfinding.createZone(node.geometry));
        }

//        if (!navmeshPlaza && node.isObject3D && node.children && node.children.length > 0) {
//            navmeshPlaza = node.children[0];
//            pathfinding.setZoneData(ZONE_plaza, Pathfinding.createZone(navmeshPlaza.geometry));
//        }


    });
});



// RAYCASTING
const raycaster = new THREE.Raycaster(); // create once
const clickMouse = new THREE.Vector2(); // create once

function intersect(pos) {
    raycaster.setFromCamera(pos, camera);
    return raycaster.intersectObjects(scene.children);
}

var modalOpened = false;
document.getElementById("map").addEventListener('click', event => {
// THREE RAYCASTER

    setTimeout(function () {
        console.log("click")
        if (!modalOpened && !orbitControlStarted) {



            clickMouse.x = ((event.clientX - renderer.domElement.offsetLeft) / renderer.domElement.width) * 2 - 1;
            clickMouse.y = -((event.clientY - renderer.domElement.offsetTop) / renderer.domElement.height) * 2 + 1;
            // console.log(document.getElementsByClassName("topnav")[0].offsetHeight)
            clickMouse.x = ((event.clientX) / window.innerWidth) * 2 - 1;
            clickMouse.y = -((event.clientY) / window.innerHeight) * 2 + 1
//    clickMouse.y = -((event.clientY - document.getElementsByClassName("topnav")[0].offsetHeight) / window.innerHeight) * 2 + 1;


            const found = intersect(clickMouse);

            console.log(found)

            if (found.length > 0) {
                try {
                    var foundshop = null;
                    for (var i = 0; i < found.length; i++) {
                        try {
                            if (foundshop == null) {
                                foundshop = checkIfExist(found[i].object.name);

                            }
                        } catch (e) {
                            console.log(e)
                        }
                    }

                    //  console.log(foundshop)

                    if (foundshop != null) {

                        if (foundshop != null) {



                            $('#locationdetailsmodal').modal('show');
                            $("#locationdetails-title").empty().append(foundshop.name.replaceAll('###', ' '));
                            $("#locationdetails-description").empty().append(foundshop.description);
                            $("#locationdetails-timing").empty().append("<b>Timing: &nbsp;</b>" + foundshop.timing);
                            $("#locationdetails-contactno").empty().append("<b>Contact: </b>" + foundshop.contactno);
                            $("#btnKnowMoreDetails").attr("data-href", foundshop.knowmore);
                            //$("#locationmodal").modal("show");

                            try {
                                updateDebugFields(foundshop.id.replace("text", ""));
                            } catch (e) {
                            }
                            $("#from").val(foundshop.id.replace("text", "")).trigger('change');
                            $("#btnopenwebsiteFrom").attr("websiteurl", foundshop.knowmore);
                            $("#btnopenwebsiteFrom").removeClass("d-none");
                            changeObjectColor(foundshop);

                        }
                    }

                } catch (e) {
                    console.log(e)
                }

                //startNav(event, found);
            }
        }
    }, 500);








});

function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}


function swapValues() {

    var from = $("#from").val();
    var to = $("#to").val();

    $("#from").val(to).trigger('change');
    $("#to").val(from).trigger('change');
}


function addText(position, name) {
    const loaderF = new FontLoader();

    loaderF.load('./assets/fonts/font1.json', function (font) {

        const geometry = new TextGeometry('C', {
            font: font,
            size: 1,
            height: 0.1

        });
        geometry.computeBoundingBox();
//        const material = new THREE.MeshBasicMaterial({color: 0xffff00});
        const materials = [
            new THREE.MeshPhongMaterial({color: 0xffff00, flatShading: true}), // front
            new THREE.MeshPhongMaterial({color: 0xffff00}) // side
        ];

        const plane = new THREE.Mesh(geometry, materials);
        plane.name = name;
        plane.position.x = position.x;
        plane.position.y = position.y;
        plane.position.z = position.z;
        plane.rotation.x = -90 * (Math.PI / 180);
        scene.add(plane);
    });


}


function updateDebugFields(shopname) {
    try {
//        shopname = 'bhP33';
        var foundShop = checkIfExist(shopname);
        $("#name").attr("shopname", shopname);
        $("#name").val(foundShop.name);
        $("#top").val(foundShop.top);
        $("#left").val(foundShop.left);
        $("#fontsize").val(foundShop.fontsize);
    } catch (e) {
    }
}


function getFontSize(canvasWidth, text, context, defaultFontSize, split) {

    var maxText = "";
    if (split) {
        var texts = text.split(" ");
        for (var i = 0; i < texts.length; i++) {
            if (texts[i].length > maxText.length) {
                maxText = texts[i];
            }
        }
    } else {
        maxText = text;
    }
    var fontSize = defaultFontSize;
    context.font = fontSize + "px Arial";
    var textWidth = context.measureText(maxText).width;

    while (textWidth > canvasWidth && fontSize > 0) {
        fontSize -= 10;
        context.font = fontSize + "px Arial";
        textWidth = context.measureText(maxText).width;

    }
    return fontSize;
}

function checkIfExist(name) {
    var found = null;
    //console.log(name.split("_")[0])
    for (var i = 0; i < locationdata.length; i++) {



        if (locationdata[i].id == name.replace("text", "")) {
            found = locationdata[i];
        }
    }
    return found;
}

var clickedObjects = [];
function changeObjectColor(foundShop) {
    for (var i = 0; i < clickedObjects.length; i++) {

        var material1 = new THREE.MeshPhongMaterial({
            color: new THREE.Color(clickedObjects[i].color)
        });
        var shopObj = scene.getObjectByName(clickedObjects[i].id.replace("text", ""));
        shopObj.material = material1;
        shopObj.material.needsUpdate = true;
    }

    clickedObjects = [];
    clickedObjects.push(foundShop);

    var material2 = new THREE.MeshPhongMaterial({
        color: new THREE.Color(0x00d7ea)
    });

    var shop = scene.getObjectByName(foundShop.id.replace("text", ""));
    shop.material = material2;
    shop.material.needsUpdate = true;

    setPositionToShop(foundShop);



}

function setPositionToShop(foundShop) {
    var shopP = scene.getObjectByName(foundShop.id.replace("text", "") + "text");



    resetAllPos();
    var x = true;

    if (x) {



        camera.position.x = 0;
        camera.position.y = 30;
        camera.position.z = 0;

        scene.position.x = shopP.position.x;
        scene.position.z = shopP.position.z;

    } else {
        camera.position.x = 0;
        camera.position.y = 0;
        scene.position.x = 0;
        scene.position.y = 0;
        scene.position.z = 0;

        if (shopP.position.z < 0) {

            camera.position.z = shopP.position.z + 30;
        } else {
            camera.position.z = (-1) * (shopP.position.z + 10);
        }
        //sh1,sh2,sh3

        var specialposition = false;

        specialposition = (foundShop.id == "sh1" || foundShop.id == "sh3" || foundShop.id == "sh2");


        scene.position.x = shopP.position.x;

        if (specialposition) {

            camera.position.z = (-1) * (shopP.position.z + 10);
            scene.position.x = shopP.position.x - 5;
            camera.position.x = 5;

        }





        //orbitControls.target.set(0, 0, camera.position.z);
    }
//    console.log(orbitControls)
//    console.log(scene.rotation);
//    scene.rotation.y = -(180 * (Math.PI / 180));
//    camera.rotation.y = -(180 * (Math.PI / 180));
//    console.log(scene.rotation);
    orbitControls.update();



}

function getStopNavFlag() {
    return stopNavClicked;
}

function stopNavigation() {
    cameraLastPosition = camera.position;
//    camera.rotation.y = -(180 * (Math.PI / 180));

//    orbitControls.update();


    camera.position.y = 50;
    camera.position.z = 0;
    camera.position.x = 0;



    scene.position.x = agentGroup.position.x;
    scene.position.z = agentGroup.position.z;


    orbitControls.update();



    stopNavClicked = true;
    navpath = [];
    $("#btnStopNav").addClass("d-none");
    $("#btnResumepNav").removeClass("d-none");
}

function resumeNavigation() {
    //  navpath = currentNavPath;
    stopNavClicked = false;

}



function startNavigation() {

    if (stopNavClicked) {
        cameraLastPosition = camera.position.y;
    }


    agentGroup.visible = true;
    $("#locationmodal").modal("hide");
    $("#btnStopNav").removeClass("d-none");
    $("#btnResumepNav").addClass("d-none");
    // orbitControls.enablePan = false;
    scene.position.x = 0;
    scene.position.y = 0;
    scene.position.z = 0;
    var shop = scene.getObjectByName($("#from").val() + "text");
    agentGroup.position.x = shop.position.x;
    agentGroup.position.y = shop.position.y;
    agentGroup.position.z = shop.position.z;



    stopNavClicked = false;
    var fromObj = checkIfExist($("#from").val());
    var toObj = checkIfExist($("#to").val());
    const agentpos = agentGroup.position;
    var to = scene.getObjectByName($("#to").val() + "text");
    let target = to.position;
//target.y=0;
    var tempTargeTempShortest1;



    if (fromObj.level != toObj.level) {


        var tempNavPath = [];

        var stairs = fromObj.stair.split(",");
        let targetTemp;
        let selectedStairs;
        let finalnavpath = [];
        let totalDistanceTemp = 0;

        if (fromObj.level == "Ground") {
            stairs = toObj.stair.split(",");
        }

        for (var st = 0; st < stairs.length; st++) {


            var toTemp = scene.getObjectByName(stairs[st]);

            targetTemp = toTemp.position;

            var ZONE = ZONE_plaza;
            if ($("#from option:selected").text().indexOf("Ground)") > -1) {

                ZONE = ZONE_ground;

//                toTemp = scene.getObjectByName(toObj.stair.split(",")[st]);
//                console.log(toObj.stair.split(",")[st]);
//                console.log(toTemp);
//                targetTemp = toTemp.position;

            }

            groupID = pathfinding.getGroup(ZONE, agentGroup.position);
            const closest = pathfinding.getClosestNode(agentpos, ZONE, groupID);


            const targetTempclosest = pathfinding.getClosestNode(targetTemp, ZONE, groupID);
            var navpath1 = pathfinding.findPath(closest.centroid, targetTempclosest.centroid, ZONE, groupID);


            // if (tempNavPath.length == 0) {
            tempNavPath = navpath1;
            tempTargeTempShortest1 = targetTemp;
            selectedStairs = stairs[st];

            //}

            //   console.log(stairs[st] + "-->" + getDistance(navpath1));


            ZONE = ZONE_plaza;
            if ($("#to option:selected").text().indexOf("Ground)") > -1) {

                ZONE = ZONE_ground;
            }
            groupID = pathfinding.getGroup(ZONE, tempTargeTempShortest1);

            const closestTemp = pathfinding.getClosestNode(tempTargeTempShortest1, ZONE, groupID);
            const targetclosest = pathfinding.getClosestNode(target, ZONE, groupID);
            var navpath2 = pathfinding.findPath(closestTemp.centroid, targetclosest.centroid, ZONE, groupID);


            var distance1 = getDistance(navpath1);
            var distance2 = getDistance(navpath2);
            var totalDistance = distance1 + distance2;

            if (st == 0) {

                for (var n = 0; n < navpath1.length; n++) {
                    finalnavpath.push(navpath1[n]);
                }
                for (var n = 0; n < navpath2.length; n++) {
                    finalnavpath.push(navpath2[n]);
                }
                totalDistanceTemp = totalDistance;
            }

            if (totalDistanceTemp > totalDistance) {
                finalnavpath = [];
                for (var n = 0; n < navpath1.length; n++) {
                    finalnavpath.push(navpath1[n]);
                }
                for (var n = 0; n < navpath2.length; n++) {
                    finalnavpath.push(navpath2[n]);
                }
                totalDistanceTemp = totalDistance;

            }



        }

        // console.log(selectedStairs);





        navpath = finalnavpath;



    } else if (fromObj.level == 'Plaza'
            && toObj.level == 'Plaza'
            && fromObj.areazone != toObj.areazone
            && fromObj.bridgeto != toObj.areazone) {


        var tempNavPath = [];

        var stairs = fromObj.stair.split(",");
        let targetTemp;
        var tempTargeTempShortest1;



        for (var st = 0; st < stairs.length; st++) {


            var toTemp = scene.getObjectByName(stairs[st]);

            targetTemp = toTemp.position;

            var ZONE = ZONE_plaza;

            groupID = pathfinding.getGroup(ZONE, agentGroup.position);
            const closest = pathfinding.getClosestNode(agentpos, ZONE, groupID);
            const targetTempclosest = pathfinding.getClosestNode(targetTemp, ZONE, groupID);

            var navpath1 = pathfinding.findPath(closest.centroid, targetTempclosest.centroid, ZONE, groupID);
            if (tempNavPath.length == 0) {
                tempNavPath = navpath1;
                tempTargeTempShortest1 = targetTemp;
            }



            if (getDistance(tempNavPath) > getDistance(navpath1)) {
                tempNavPath = navpath1;
                tempTargeTempShortest1 = targetTemp;
            }
        }






        ZONE = ZONE_ground;

        groupID = pathfinding.getGroup(ZONE, tempTargeTempShortest1);

        const fromTempClosest = pathfinding.getClosestNode(tempTargeTempShortest1, ZONE, groupID);



        var tempNavPath2 = [];

        var stairs2 = toObj.stair.split(",");

        var targetTempShortest;

        for (var st = 0; st < stairs2.length; st++) {

            toTemp = scene.getObjectByName(stairs2[st]);
            console.log(toTemp);
            targetTemp = toTemp.position;

            groupID = pathfinding.getGroup(ZONE, targetTemp);

            const closestTemp = pathfinding.getClosestNode(targetTemp, ZONE, groupID);

            var navpath2 = pathfinding.findPath(fromTempClosest.centroid, closestTemp.centroid, ZONE, groupID);
            var distance = getDistance(navpath2);
            // console.log(stairs2[st] + " --> " + distance);

            if (tempNavPath2.length == 0) {
                tempNavPath2 = navpath2;
                targetTempShortest = targetTemp;
            }




            if (getDistance(tempNavPath2) > getDistance(navpath2)) {
                tempNavPath2 = navpath2;
                targetTempShortest = targetTemp;
            }
        }

        // console.log("choosen --> " + getDistance(tempNavPath2));



        ZONE = ZONE_plaza;
        groupID = pathfinding.getGroup(ZONE, targetTempShortest);
        const fromTempClosest2 = pathfinding.getClosestNode(targetTempShortest, ZONE, groupID);

        const targetclosest2 = pathfinding.getClosestNode(target, ZONE, groupID);

        var navpath3 = pathfinding.findPath(fromTempClosest2.centroid, targetclosest2.centroid, ZONE, groupID);



        var navPathFull = tempNavPath;


        for (var n = 0; n < tempNavPath2.length; n++) {
            navPathFull.push(tempNavPath2[n]);
        }

        for (var n = 0; n < navpath3.length; n++) {
            navPathFull.push(navpath3[n]);
        }

        navpath = navPathFull;



    } else {


        var ZONE = ZONE_plaza;
        if ($("#from option:selected").text().indexOf("Ground)") > -1) {

            ZONE = ZONE_ground;
        }



        groupID = pathfinding.getGroup(ZONE, agentGroup.position);
        const closest = pathfinding.getClosestNode(agentpos, ZONE, groupID);
        const targetclosest = pathfinding.getClosestNode(target, ZONE, groupID);

        navpath = pathfinding.findPath(closest.centroid, targetclosest.centroid, ZONE, groupID);


    }




    if (navpath) {
        console.log(target);
        pathfindinghelper.reset();
        pathfindinghelper.setPlayerPosition(agentpos);
        pathfindinghelper.setTargetPosition(target);
        pathfindinghelper.setPath(navpath);
        navStarted = true;
    }

}

function getDistance(distancePath) {

    var distance = 0;
    try {
        for (var n = 0; n < distancePath.length; n++) {
            if (n + 1 < distancePath.length) {
                var tempDistance = distancePath[n].distanceTo(distancePath[n + 1]);
                if (tempDistance < 0) {
                    tempDistance = (-1) * tempDistance;
                }
                distance += tempDistance;
            }
        }
    } catch (e) {
    }
    return distance;

}

let secs = 0,
        fps_update = 20,
        fps_movement = 30,
        frame = 0,
        frameMax = 300;
// MOVEMENT ALONG PATH

function move(delta) {
    currentNavPath = navpath;
    if (!navpath || navpath.length <= 0)
        return;
    let targetPosition = navpath[ 0 ];

    const distance = targetPosition.clone().sub(agentGroup.position);
    const oldObjectPosition = new THREE.Vector3();
    agentGroup.getWorldPosition(oldObjectPosition);
    if (distance.lengthSq() > 0.05 * 0.05) {
        distance.normalize();
        agentGroup.position.add(distance.multiplyScalar(delta * SPEED));
//        agentGroup.position.y=4;
    } else {
        // Remove node from the path we calculated
        navpath.shift();
        previousPos = targetPosition;
    }




}

// GAMELOOP
const clock = new THREE.Clock();
let gameLoop = () => {
    move(clock.getDelta());
    updateCamera();
    renderer.render(scene, camera);
    requestAnimationFrame(gameLoop);
};
gameLoop();
function updateCamera() {




    if (!navpath || navpath.length == 0) {
        setToEndPosition();
        return;
    }

    thirdPersonCamera.Update();
}


function loadText(scene) {



    const loaderF = new FontLoader();
    loaderF.load('./assets/fonts/font1.json', function (font) {


        loadData(scene, font);
    });
}

function updateTextInModel() {
    var shopid = $("#name").attr("shopname");
    try {

        var shop = scene.getObjectByName(shopid + "text");
        const y = (shop.geometry.boundingBox.max.z - shop.geometry.boundingBox.min.z) * shop.scale.z * 100; // model =y
        const x = (shop.geometry.boundingBox.max.x - shop.geometry.boundingBox.min.x) * shop.scale.x * 100; // model=x

        var width, height;
        if (y > x) {
            width = x;
            height = y;
        } else {
            width = y;
            height = x;
        }

        width = x;
        height = y;
        var texts = $("#name").val().split("###");
        var top = parseInt($("#top").val());
        var left = parseInt($("#left").val());
        left = width / 2;
        var fontSize = parseInt($("#fontsize").val());
        var dynamicTexture = new THREEx.DynamicTexture(width, height, fontSize);
        for (var j = 0; j < texts.length; j++) {

            dynamicTexture.context.font = fontSize + "px Gotham Narrow Black";
            dynamicTexture.drawText(texts[j], left, top, 'red');
            top += fontSize + 5;
        }
        var material = new THREE.MeshBasicMaterial({
            map: dynamicTexture.texture,
            transparent: true
        });
        shop.material = material;
    } catch (e) {
    }
}
;
function updateValues() {
//    if (confirm("Are you sure, you want to update values?")) {

    if ($("#left").val() != "" && $("#top").val() != "" && $("#fontsize").val() != "" && $("#name").val() != "") {

        $.ajax({
            url: 'http://localhost:8080/AbookProjects/update.jsp',
            method: 'post',
            data: {
                left: $("#left").val(),
                top: $("#top").val(),
                fontsize: $("#fontsize").val(),
                name: $("#name").val(),
                id: $("#name").attr("shopname")
            },
            success: function (data) {
                if (data.data) {
                    $("#msg").empty().append("updated");
                } else {
                    $("#msg").empty().append("Error");
                }
            }});
    }
//    }
}

function updateCameraPosition(type) {

    switch (type) {
        case 'left':
            scene.position.x = scene.position.x - 5;
            break;
        case 'right':
            scene.position.x = scene.position.x + 5;
            break;
        case 'top':
            camera.position.z = camera.position.z + 5;
            break;
        case 'down':
            camera.position.z = camera.position.z - 5;
            break;
    }

}

var locationdata = [];
function loadData(scene, font) {
    $.ajax({
        url: locations_url,
        method: 'get',
        success: function (data) {

            $("#btnleft").on("click", function () {
                updateCameraPosition('left');
            });
            $("#btnright").on("click", function () {
                updateCameraPosition('right');
            });
            $("#btnup").on("click", function () {
                updateCameraPosition('up');
            });
            $("#btndown").on("click", function () {
                updateCameraPosition('down');
            });
            $("#searchlink").on("click", function () {
                $("#locationmodal").modal("show");
            });

//            $("#whatsonlink").on("click", function () {
//                $("#whatonmodal").modal("show");
//            });


            $("#btnopenwebsiteFrom").on("click", function () {
                window.open($(this).attr("websiteurl"));
            });
            $("#btnopenwebsiteTo").on("click", function () {
                window.open($(this).attr("websiteurl"));
            });
            $("#locationmodal").on("hidden.bs.modal", function () {
                $("#btnopenwebsite").attr("websiteurl", "");
                $("#btnopenwebsite").addClass("d-none");
                setTimeout(function () {
                    modalOpened = false;
                }, 1000);
            });
            $("#locationmodal").on("shown.bs.modal", function () {

                modalOpened = true;
            });
            $("#btnclose").on("click", function () {
                $("#locationmodal").modal("hide");
            })


            $("#btnnav").on("click", function () {
                if ($("#from").val() != '0' && $("#to").val() != '0') {
                    startNavigation();
                }
            });
            $(".form-control").each(function () {
                $(this).on("keyup", function () {
                    updateTextInModel();
                });
            });
            $("#btnsave").on("click", function () {
                updateValues();
            });
            $("#btnStopNav").on("click", function () {
                stopNavigation();
            });

            $("#btnResumepNav").on("click", function () {
                startNavigation();
            });


            $("#btnKnowMoreDetails").on("click", function () {

                window.open($(this).attr("data-href"));
                return false;
            });


            $("#btnTopView").on("click", function () {
                topView();
            });

            $("#btnadd").on("click", function () {

                var shopid = $("#name").attr("shopname");
                var shop = scene.getObjectByName(shopid);
                addText(shop.position, shopid + "newtext");
            });
//            console.log(data)

            $("#from").on("change", function () {
                try {
                    var fromObj = checkIfExist($("#from").val());

                    $("#btnopenwebsiteFrom").attr("websiteurl", fromObj.knowmore);
                } catch (e) {
                }
            });

            $("#to").on("change", function () {
                try {
                    var toObj = checkIfExist($("#to").val());
                    $("#btnopenwebsiteTo").attr("websiteurl", toObj.knowmore);
                } catch (e) {
                }
            });

            $("#swapbtn").on("click", function () {

                swapValues();

            });



            $("#from").empty().append("<option value='0'>Select from</option>");
            $("#to").empty().append("<option value='0'>Select destination</option>");
            for (var i = 0; i < data.length; i++) {

                if (data[i].name != "") {
                    var option = $("<option></option>");
                    $(option).append(data[i].name.replaceAll("###", " ") + " (" + capitalizeFirstLetter(data[i].areazone) + " " + data[i].level + ")");
                    $(option).attr("value", data[i].id);
                    $(option).attr("category", data[i].category);
                    $("#from").append(option);
                    var option2 = $("<option></option>");
                    $(option2).append(data[i].name.replaceAll("###", " ") + " (" + capitalizeFirstLetter(data[i].areazone) + " " + data[i].level + ")");
                    $(option2).attr("value", data[i].id);
                    $(option2).attr("category", data[i].category);
                    $("#to").append(option2);
                    try {
                        var shop = scene.getObjectByName(data[i].id + "text");
//                        if (data[i].level == 'Plaza') {
//
//                            shop.rotation.y = shop.rotation.y - (180 * (Math.PI / 180));
//                        }

                        const y = (shop.geometry.boundingBox.max.z - shop.geometry.boundingBox.min.z) * shop.scale.z * 100; // model =y
                        const x = (shop.geometry.boundingBox.max.x - shop.geometry.boundingBox.min.x) * shop.scale.x * 100; // model=x
                        var width, height;
                        width = x;
                        height = y;
                        var texts = data[i].name.split("###");
                        var top = parseInt(data[i].top);
                        var left = parseInt(data[i].left);
                        var fontSize = parseInt(data[i].fontsize);
                        var dynamicTexture = new THREEx.DynamicTexture(width, height, fontSize);
                        for (var j = 0; j < texts.length; j++) {

                            dynamicTexture.context.font = fontSize + "px Gotham Narrow Medium";
                            if (data[i].level == 'Plaza') {
                                dynamicTexture.drawText(texts[j], width / 2, top, 'white');
                            } else
                            if (data[i].id == 'rmBR01' || data[i].id == 'rmBR02') {
                                dynamicTexture.drawText(texts[j], width / 2, top, 'white');
                            } else {
                                dynamicTexture.drawText(texts[j], width / 2, top, 'white');
                            }


                            // dynamicTexture.drawText(texts[j], width / 2, top, 'black');
                            top += fontSize + 5;
                        }

                        var material = new THREE.MeshPhongMaterial({
                            map: dynamicTexture.texture,
                            transparent: true
                        });
                        shop.material = material;
                        data[i].material = shop.material;
                        shop.material.needsUpdate = true;

                        shop.rotation.y = (173 * (Math.PI / 180));
//0x8fe6df
//                        var shopBack = scene.getObjectByName(data[i].id);
//                        if (shopBack) {
////                        console.log(shopBack.name)
//                            var material2 = new THREE.MeshPhongMaterial({
//                                color: new THREE.Color("0xffffff")
//                            });
//                            shopBack.material = material2;
//                            shopBack.material.needsUpdate = true;
//                        }
                    } catch (e) {
                        console.log(e)
                    }
                } else {
                    try {
                        var shop = scene.getObjectByName(data[i].id + "text");



                        var top = parseInt(data[i].top);
                        var left = parseInt(data[i].left);
                        var fontSize = parseInt(data[i].fontsize);
                        var dynamicTexture = new THREEx.DynamicTexture(20, 20, fontSize);
                        var material = new THREE.MeshPhongMaterial({
                            map: dynamicTexture.texture,
                            transparent: true
                        });
                        shop.material = material;
                        data[i].material = shop.material;
                        shop.material.needsUpdate = true;
                    } catch (e) {
                    }

                }




            }

            locationdata = data;
            loadLines();
        }});
}

var THREEx = THREEx || {}

//////////////////////////////////////////////////////////////////////////////////
//		Constructor							//
//////////////////////////////////////////////////////////////////////////////////

/**
 * create a dynamic texture with a underlying canvas
 *
 * @param {Number} width  width of the canvas
 * @param {Number} height height of the canvas
 */
THREEx.DynamicTexture = function (width, height, fontheight) {
    var canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height

    this.canvas = canvas

    var context = canvas.getContext('2d')
//    context.scale(-1, 1);
//    context.scale(1, -1);
    if (fontheight) {
        context.font = fontheight + "px serif";
    } else {
        context.font = "100px serif";
    }
    context.textAlign = "center";
//     this.context.globalAlpha = 0.5;
//    context.clearRect(0, 0, canvas.width, canvas.height);
//    context.translate(width / 2, height / 2);
    this.context = context


    var texture = new THREE.Texture(canvas)
    texture.flipY = false;
    this.texture = texture
}

//////////////////////////////////////////////////////////////////////////////////
//		methods								//
//////////////////////////////////////////////////////////////////////////////////

/**
 * clear the canvas
 *
 * @param  {String*} fillStyle 		the fillStyle to clear with, if not provided, fallback on .clearRect
 * @return {THREEx.DynamicTexture}      the object itself, for chained texture
 */
THREEx.DynamicTexture.prototype.clear = function (fillStyle) {
// depends on fillStyle
    if (fillStyle !== undefined) {
        this.context.fillStyle = fillStyle
        this.context.fillRect(0, 0, this.canvas.width, this.canvas.height)
    } else {
        this.context.clearRect(0, 0, this.canvas.width, this.canvas.height)
    }
// make the texture as .needsUpdate
    this.texture.needsUpdate = true;
    // for chained API
    return this;
}

/**
 * draw text
 *
 * @param  {String}		text	- the text to display
 * @param  {Number|undefined}	x	- if provided, it is the x where to draw, if not, the text is centered
 * @param  {Number}		y	- the y where to draw the text
 * @param  {String*} 		fillStyle - the fillStyle to clear with, if not provided, fallback on .clearRect
 * @param  {String*} 		contextFont - the font to use
 * @return {THREEx.DynamicTexture}	- the object itself, for chained texture
 */
THREEx.DynamicTexture.prototype.drawText = function (text, x, y, fillStyle, contextFont) {
// set font if needed
    if (contextFont !== undefined)
        this.context.font = contextFont;
    // if x isnt provided
    if (x === undefined || x === null) {
        var textSize = this.context.measureText(text);
        x = (this.canvas.width - textSize.width) / 2;
    }
// actually draw the text
    this.context.fillStyle = fillStyle;
    this.context.fillText(text, x, y);
//    this.context.globalAlpha = 0.0;
    // make the texture as .needsUpdate
    this.texture.needsUpdate = true;
    // for chained API
    return this;
};
THREEx.DynamicTexture.prototype.drawTextCooked = function (options) {
    var context = this.context
    var canvas = this.canvas
    options = options || {}
    var text = options.text
    var params = {
        margin: options.margin !== undefined ? options.margin : 0.1,
        lineHeight: options.lineHeight !== undefined ? options.lineHeight : 0.1,
        align: options.align !== undefined ? options.align : 'left',
        fillStyle: options.fillStyle !== undefined ? options.fillStyle : 'red',
        font: options.font !== undefined ? options.font : "bold " + (0.2 * 512) + "px Arial",
    }
    // sanity check
    console.assert(typeof (text) === 'string')

    context.save()
    context.fillStyle = params.fillStyle;
    context.font = params.font;
    var y = (params.lineHeight + params.margin) * canvas.height
    while (text.length > 0) {
        // compute the text for specifically this line
        var maxText = computeMaxTextLength(text)
        // update the remaining text

        text = text.substr(maxText.length)
        console.log(text)

        // compute x based on params.align
        var textSize = context.measureText(maxText);
        if (params.align === 'left') {
            var x = params.margin * canvas.width
        } else if (params.align === 'right') {
            var x = (1 - params.margin) * canvas.width - textSize.width
        } else if (params.align === 'center') {
            var x = (canvas.width - textSize.width) / 2;
        } else
            console.assert(false)

        // actually draw the text at the proper position
        this.context.fillText(maxText, x, y);
        // goto the next line
        y += params.lineHeight * canvas.height
    }
    context.restore()

    // make the texture as .needsUpdate
    this.texture.needsUpdate = true;
    // for chained API
    return this;
    function computeMaxTextLength(text) {
        var maxText = ''
        var maxWidth = (1 - params.margin * 2) * canvas.width
        while (maxText.length !== text.length) {
            var textSize = context.measureText(maxText);
            if (textSize.width > maxWidth)
                break;
            maxText += text.substr(maxText.length, 1)
        }
        return maxText
    }
}

/**
 * execute the drawImage on the internal context
 * the arguments are the same the official context2d.drawImage
 */
THREEx.DynamicTexture.prototype.drawImage = function (/* same params as context2d.drawImage */) {
// call the drawImage
    this.context.drawImage.apply(this.context, arguments)
    // make the texture as .needsUpdate
    this.texture.needsUpdate = true;
    // for chained API
    return this;
};




